import React, { useCallback } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { globalTheme } from "@cld/component-theme";
import { useSelectedAsset } from "../../selectors";
import Format from "./Format";
import Summary from "./Summary";

const PreviewBox = styled.div`
	background: ${globalTheme.palette.surface};
	box-shadow: ${globalTheme.shadow.md};
	flex-grow: 1;
	z-index: 2;
	overflow: auto;
`;

export default ({ selectAssetFormat }) => {
	const dispatch = useDispatch();
	const { selectedAsset, selectedFormat } = useSelectedAsset();

	const handleSelectAssetFormat = useCallback((payload) => {
		dispatch(selectAssetFormat(payload));
	}, [dispatch, selectAssetFormat]);

	return (
		<PreviewBox data-test="purchase-info-section">
			<Format selectedAsset={selectedAsset} selectedFormat={selectedFormat} selectAssetFormat={handleSelectAssetFormat} />
			<Summary selectedAsset={selectedAsset} />
		</PreviewBox>
	);
};

